document.addEventListener('DOMContentLoaded', () => {
   // Nav @ Prevent Click
   document.querySelectorAll('._prevent-default > a').forEach(link => {
      link.addEventListener('click', e => {
         e.preventDefault();
      });
   });

   // Hamburger Menu
   const toggleSelectors = [
      '.menu-mobile button.hamburger',
      '.menu-mobile button.btn-close',
      '.menu-mobile nav li:not(.menu-item-has-children) > a'
   ];

   toggleSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
         el.addEventListener('click', () => {
            document.querySelector('body').classList.toggle('menu-mobile-opened');
            document.querySelector('.menu-mobile button.hamburger').classList.toggle('active');
         });
      });
   });

   // Mobile Submenu Toggle
   document.querySelectorAll('.menu-mobile nav > ul > li.menu-item-has-children').forEach(item => {
      const submenu = item.querySelector('.sub-menu');

      if (!submenu) return;

      submenu.style.overflow = 'hidden';
      submenu.style.height = '0';
      submenu.style.transition = 'height 0.4s ease-out';

      item.addEventListener('click', (e) => {
         e.preventDefault();
         item.classList.toggle('active');

         if (submenu.style.height === '0px' || submenu.style.height === '0') {
            submenu.style.height = submenu.scrollHeight + 'px';
         } else {
            submenu.style.height = '0';
         }
      });
   });

});
